import React from 'react';
import Helmet from 'react-helmet';

const MetaInfo = (props) => {

    return (
        <>
            {props.lang !== 'fr' ?
                <Helmet>
                    <title>Our Lettuce</title>
                    <meta name="description" content="At A&W, we always use fresh iceberg lettuce from our partners at Church Brothers Farms." />
                </Helmet>
            :
                <Helmet>
                    <title>Notre laitue</title>
                    <meta name="description" content="Chez A&W, nous utilisons de la laitue iceberg fraîche produite par nos partenaires de Church Brothers Farms." />
                </Helmet>
            }
        </>
    )
}
export default MetaInfo;